import { render, staticRenderFns } from "./head_modules.vue?vue&type=template&id=23ad92b1&scoped=true"
import script from "./head_modules.vue?vue&type=script&lang=js"
export * from "./head_modules.vue?vue&type=script&lang=js"
import style0 from "./head_modules.vue?vue&type=style&index=0&id=23ad92b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad92b1",
  null
  
)

export default component.exports